export const Utils = {
    addPhonePrefixIfNeeded: (phoneNumber, prefix = '+48') => {
        if (prefix === '+48') {
            return '+48 ' + phoneNumber.slice(-9);
        }
        return phoneNumber;
    }
};
